import React from "react";
import {useModalContext} from "../../../providers/ModalProvider";

export const Image = ({url}:
                            {
  url: string
                            }
) => {
  const {openModal} = useModalContext();
  return (
    <div contentEditable={false}>
      <img
        src={url}
        alt="Image"
        className="max-w-full max-h-[300px] shadow-elevation-1"
        onError={(e) => {
          const fallbackDiv = e.currentTarget.parentNode as HTMLDivElement;
          if (fallbackDiv) {
            fallbackDiv.innerHTML = `
              <a href="${url}" target="_blank" rel="noopener noreferrer" class="text-blue-1 underline">
                ${url}
              </a>
            `;
          }
        }}
        onClick={() => {
          openModal((
            <div
              className="">
              <img src={url} alt="preview" className={"max-w-[90vw] max-h-[90vh]"}/>
            </div>
          ))
        }}
      />
    </div>
  );
}